import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { tabletMediaQuery, themeColor, useBreakPoints } from '../../Theming';

const Container = styled.div`
  width: 100%;
  height: 135px;
  background-color: ${themeColor('fernGreen')};
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  color: ${themeColor('white')};

  ${tabletMediaQuery} {
    display: block;
    padding: 50px 50px 0px 50px;
    position: relative;
    bottom: 0px;
  }
`;

const Description = styled.p`
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 17px;

  ${tabletMediaQuery} {
    font-size: 12px;
    line-height: 17px;
    margin-top: 0px;
    margin-bottom: 0px;
  }
`;

const Footer: React.FC = () => {
  const { t } = useTranslation();
  const { mobile } = useBreakPoints();

  return (
    <Container>
      {mobile ? (
        <>
          <Description>{t('treePlanting.poweredBy')}</Description>
          <Description>{t('treePlanting.poweredByPartners')}</Description>
        </>
      ) : (
        <Description>{t('treePlanting.poweredByFull')}</Description>
      )}
    </Container>
  );
};

export default Footer;
